import { useEffect } from 'react'
import { usePageTitle } from '@/hooks/use-document-title'
import { posthog } from '@/lib/posthog'
import { ExtraCredit } from './homework/extra-credit'
import { HomeworkSection } from './homework/homework-section'
import { TaskDetailDialog } from './homework/task-detail-dialog'
import { InterviewsSection } from './interviews/interviews-section'
import { MasterySection } from './mastery/mastery-section'
import { CompanyProvider } from './providers/company-provider'
import { HomeworkProvider } from './providers/homework-provider'
import { InterviewsProvider } from './providers/interviews-provider'
import { ReadinessScore } from './readiness/readiness-score'

export function Dashboard() {
  usePageTitle('Dashboard')

  useEffect(() => {
    posthog.capture('dashboard_viewed')
  }, [])

  return (
    <HomeworkProvider>
      <CompanyProvider>
        <InterviewsProvider>
          <main className="min-h-[calc(100vh-4rem)] bg-background">
            <div className="mx-auto flex w-full max-w-7xl flex-col gap-6 px-4 py-6 md:px-6">
              <ReadinessScore />
              <InterviewsSection />
              <HomeworkSection />
              <ExtraCredit />
              <MasterySection />
            </div>
          </main>
          <TaskDetailDialog />
        </InterviewsProvider>
      </CompanyProvider>
    </HomeworkProvider>
  )
}
